var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_265_498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2653 22.3914H2.73668C1.76263 22.3914 1.13181 21.3461 1.57091 20.4613L10.5909 2.33825C11.0702 1.37794 12.4092 1.3622 12.907 2.31307L22.4156 20.433C22.8795 21.3178 22.2486 22.3914 21.2622 22.3914H21.2653Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0011 19.2493C12.6842 19.2493 13.2379 18.6855 13.2379 17.9899C13.2379 17.2943 12.6842 16.7305 12.0011 16.7305C11.3179 16.7305 10.7642 17.2943 10.7642 17.9899C10.7642 18.6855 11.3179 19.2493 12.0011 19.2493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0351 15.3481C11.7197 15.3481 11.4568 15.1056 11.4321 14.7845L10.9714 9.11076C10.9219 8.49994 11.3919 7.97728 11.9949 7.97414C12.5948 7.97099 13.071 8.4905 13.0308 9.09817L12.6319 14.7782C12.6102 15.0962 12.3505 15.3449 12.0351 15.3481Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_265_498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoWarning);
export default __webpack_public_path__ + "static/media/ico-warning.b8f3c78c7590d78ec459d5759b31c520.svg";
export { ForwardRef as ReactComponent };